const translations = {
    'tools.farmers': 'Przydzielone rolnikom',
    'tools.hunters': 'Przydzielone myśliwym',
    'tools.item': '%s • %.1f',
    'tools.noneAssigned': 'Brak przydzielonych narzędzi.',
    'tools.noneStorage': 'Brak narzędzi w magazynie.',
    'tools.unassigned': 'Narzędzia nieprzydzielone',
};

export default translations;
